module.exports = __webpack_public_path__ + "img/no_data.ad17058e.svg";